import React from "react";
import {useLocation} from "react-router-dom";

function TransactionFailedPage() {
    const {state} = useLocation();

    let errorRedirectionUrl = state != null ? state?.errorRedirectionUrl : undefined;
    const errorMessage = state != null ? state?.errorMessage : undefined;
    const merchantName = state != null ? state?.shopName : undefined;
    let failedPaymentReference = state != null ? state?.paymentReference : undefined;

    let timeLeft = 10;

    const redirectUser = () => {
        if (errorRedirectionUrl == undefined || errorRedirectionUrl === '') {
            return;
        } else {
            const newErrorRedirectionUrl = new URL(`${errorRedirectionUrl}`);

            if (failedPaymentReference == undefined) {
                failedPaymentReference = ""
            }
            newErrorRedirectionUrl.searchParams.set("payment_reference", failedPaymentReference)

            window.location.href = newErrorRedirectionUrl;
        }
    }

    let downloadTimer = setInterval(function () {
        if (errorRedirectionUrl == undefined || errorRedirectionUrl === '') return;

        if (timeLeft <= 0) {
            clearInterval(downloadTimer);
            redirectUser()
        } else {
            document.getElementById("errorCountdown").innerHTML = timeLeft;
        }
        timeLeft -= 1;
    }, 1000);

    return (<div className="flex flex-col items-center justify-center h-screen">

        <div className="mt-4 mb-2 mx-auto">
            <img
                src="/hellopay.svg"
                className="my-2 sm:mb-8 mx-auto w-auto h-[50px]"
                alt={"logo"}
            />
            <img
                src="/hellopayFailedIcon.svg"
                className="mt-4 mb-2 mx-auto h-[200px] sm:h-[300px] w-auto"
                alt={"logo"}
            />
        </div>

        <div className="flex space-x-2 my-2 sm:mt-6
                        font-bold text-[32px] sm:text-[40px]">
            {errorRedirectionUrl == undefined || errorRedirectionUrl === '' ?
                <div className="mr-1">Transaction</div> :
                <div className="mr-1">Payment</div>}
            <div className="text-[#e53e3e]">Failed</div>
        </div>


        {errorRedirectionUrl == undefined || errorRedirectionUrl === '' ?
            <div className="align-center mb-4 text-xs sm:text-base text-[#948F9F]">{errorMessage}</div> :

            <div className="align-center mb-4 text-xs sm:text-base text-[#948F9F]">
                <div>Your payment was unsuccessful.</div>
                <button
                    className="mt-8 mb-2 px-4 py-2 rounded-md flex justify-between items-center space-x-3 hover:shadow-xl disabled:shadow-none
                    bg-gradient-to-r from-purple to-very_dark_grayish_violet disabled:opacity-50 text-sm text-white uppercase"
                    onClick={(e) => {
                        const btn = e.currentTarget;
                        btn.disabled = true;
                        redirectUser();
                    }}
                >
                    <span className="text-xs sm:text-sm">Return to store</span>
                    <div className="mx-auto flex items-center justify-center">
                        <div className="relative z-10 flex items-center overflow-hidden rounded-full p-[1.5px]">
                            <div
                                className="animate-rotate absolute inset-0 h-full rounded-full bg-[conic-gradient(transparent_180deg,#FFFFFF_20deg)]"
                            />
                            <div
                                className="relative z-20 flex rounded-full bg-very_dark_grayish_violet "
                            >
                                <div id="errorCountdown" className="sm:p-0.5 w-5 sm:w-7 h-5 sm:h-7"/>
                            </div>
                        </div>
                    </div>
                </button>
            </div>}

    </div>);
}

export default TransactionFailedPage;